import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-range-input", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("range-input", "with-label"),
            componentTag: "ux-range-input",
            pageHeight: 220,
            pageWidth: 400,
        });
    });
});
